import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Save } from 'lucide-react';
import usePageContent from './usePageContent';
import PageHeroEditor from './PageHeroEditor';
import LivePreviewPanel, { ContactPreview } from './LivePreviewPanel';

const defaults = {
  hero: {
    title: 'Get in',
    highlight: 'Touch',
    description:
      'Have questions or need assistance? We\'re here to help. Reach out to us through any of the channels below.',
  },
  form: {
    heading: 'Send us a Message',
    subheading: 'Fill out the form below and we\'ll get back to you shortly',
  },
};

const ContactContentEditor = () => {
  const [showPreview, setShowPreview] = useState(false);
  const { loading, saving, sections, setSections, saveSection } = usePageContent({
    pageName: 'contact',
    defaultsBySection: defaults,
  });

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Live Preview Panel */}
      <LivePreviewPanel 
        pageName="contact" 
        showPreview={showPreview} 
        setShowPreview={setShowPreview}
      >
        <ContactPreview content={sections} />
      </LivePreviewPanel>

      <PageHeroEditor
        title={sections.hero.title}
        setTitle={(v) => setSections({ ...sections, hero: { ...sections.hero, title: v } })}
        highlight={sections.hero.highlight}
        setHighlight={(v) => setSections({ ...sections, hero: { ...sections.hero, highlight: v } })}
        description={sections.hero.description}
        setDescription={(v) => setSections({ ...sections, hero: { ...sections.hero, description: v } })}
        onSave={() => saveSection('hero')}
        saving={saving}
      />

      <Card>
        <CardHeader>
          <CardTitle>Form Section</CardTitle>
          <CardDescription>Heading and text shown above the contact form</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label>Heading</Label>
            <Input
              value={sections.form.heading}
              onChange={(e) => setSections({ ...sections, form: { ...sections.form, heading: e.target.value } })}
              className="mt-1"
            />
          </div>
          <div>
            <Label>Subheading</Label>
            <Textarea
              value={sections.form.subheading}
              onChange={(e) => setSections({ ...sections, form: { ...sections.form, subheading: e.target.value } })}
              className="mt-1"
              rows={2}
            />
          </div>

          <Button
            type="button"
            onClick={() => saveSection('form')}
            disabled={saving}
            className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700"
          >
            <Save className="mr-2" size={18} /> Save Form Section
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ContactContentEditor;
